module.exports = __webpack_public_path__ + "static/media/jeet.5c237f81.png";